import {create} from 'zustand';
import type {FileProgressItem} from '../types/upload';

type UploadMode = 'file' | 'folder'
type BubbleStatus = 'uploading' | 'success' | 'error' | null

interface UploadStore {
  open: boolean;
  minimized: boolean;
  mode: UploadMode;
  bubbleStatus: BubbleStatus;

  hasStartedUpload: boolean;
  progress: number;
  fileProgressList: FileProgressItem[];

  fileList: any[];

  setOpen: (open: boolean) => void;
  setMinimized: (minimized: boolean) => void;
  setMode: (mode: UploadMode) => void;
  setBubbleStatus: (status: BubbleStatus) => void;

  setHasStartedUpload: (value: boolean) => void;
  setProgress: (progress: number) => void;

  setFileProgressList: (list: FileProgressItem[]) => void;
  updateFileProgressList: (
    updater: (prev: FileProgressItem[]) => FileProgressItem[]
  ) => void;

  setFileList: (list: any[]) => void;
  updateFileList: (
    updater: (prev: any[]) => any[]
  ) => void;

  resetUploadState: () => void;
  closeUpload: () => void;
}

export const useUploadStore = create<UploadStore>(set => ({
  open: false,
  minimized: false,
  mode: 'file',
  bubbleStatus: null,

  hasStartedUpload: false,
  progress: 0,
  fileProgressList: [],

  fileList: [],

  setOpen: open => set({open}),
  setMinimized: minimized => set({minimized}),
  setMode: mode => set({mode}),
  setBubbleStatus: bubbleStatus => set({bubbleStatus}),

  setHasStartedUpload: hasStartedUpload => set({hasStartedUpload}),
  setProgress: progress => set({progress}),

  setFileProgressList: fileProgressList => set({fileProgressList}),
  updateFileProgressList: updater =>
    set(state => ({
      fileProgressList: updater(state.fileProgressList)
    })),

  setFileList: fileList => set({fileList}),
  updateFileList: updater =>
    set(state => ({
      fileList: updater(state.fileList)
    })),

  resetUploadState: () => set({
    progress: 0,
    fileProgressList: [],
    hasStartedUpload: false,
    bubbleStatus: null
  }),

  closeUpload: () => set({
    open: false,
    minimized: false,
    bubbleStatus: null
  })
}));